import { z } from 'zod'

import { listQueryZodFields } from './system'
import { WebhookEventType } from '../constants/webhook'
import { dbEntitySchema } from './system'

export const webhookVenuePermissionSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export const webhookSchema = dbEntitySchema.extend({
  enabled: z.boolean(),
  organization: z.string(),
  venues: z.array(z.object({ id: z.string(), name: z.string() })).nullish(),
  url: z.string().url(),
  events: z.array(z.nativeEnum(WebhookEventType)).min(1),
})

export const webhookListArgsSchema = z.object({
  ...listQueryZodFields,
  organizationId: z.string().optional(),
  enabled: z.boolean().optional(),
})
export const webhookCreateArgsSchema = webhookSchema
  .omit({
    _id: true,
    id: true,
    deleted: true,
    organization: true,
    created: true,
    modified: true,
    enabled: true,
  })
  .extend({
    venueIds: z.array(z.string()).nullish(),
    enabled: z.boolean().optional(),
  })

export const webhookUpdateByIdArgsSchema = webhookSchema
  .omit({
    _id: true,
    id: true,
    organization: true,
    created: true,
    modified: true,
    deleted: true,
    enabled: true,
  })
  .extend({
    venueIds: z.array(z.string()).nullish(),
    enabled: z.boolean().optional(),
  })

//responses
export const webhookListResponseSchema = z.object({
  data: z.array(webhookSchema),
})
